
const faq = [
    {
        img: '/img/static/faq/ask.svg',
        title: 'Questions fréquentes',
        questions: [
            {
                ask: 'Comment trier mes mails avec Cleanfox ? (tutoriel) ',
                answer: `Rien de plus simple. Il y a trois options de tri et deux vues disponibles :

1. **La vue "carte"** qui permet de trier vos mails un par un, affichés sous forme de cartes. Pour trier vos mails, 3 mouvements :
- **Glissez vers la gauche pour vous désabonner**. Cette option place les mails de la newsletter dans la corbeille de votre boîte mail et vous désabonne à cette newsletter.
- **Glissez vers le haut pour supprimer.** Cette option place les mails reçus dans la corbeille de votre boîte mail mais conserve votre abonnement à la newsletter.
- **Glissez vers la droite pour conserver.** Cette option conserve tous les mails et l'abonnement à la newsletter.

2. **La vue "liste"** qui affiche la liste de toutes les newsletters à trier et vous permet d'en sélectionner plusieurs à la fois. Ici, pour trier, il vous suffit de cocher la/les newsletter(s) de votre choix et cliquer sur :

- **Le rond rouge pour vous désabonner**. Cette option place les mails de la newsletter dans la corbeille de votre boîte mail et vous désabonne à cette newsletter.
- **La poubelle orange pour supprimer.** Cette option place les mails reçus dans la corbeille de votre boîte mail mais conserve votre abonnement à la newsletter.
- **La boite verte pour conserver**. Cette option conserve tous les mails et l'abonnement à la newsletter.`
            },
            {
                ask: `Mon adresse mail n'est pas reconnue`,
                answer: `Lors de la création de votre compte, il se peut que vous receviez le message d'erreur suivant : "Oops, .... n'est pas une adresse mail traitée par Cleanfox".

En effet, Cleanfox ne traite pas les adresses mails personnalisées *(exemple : jeanne@dupont.fr)* et n'est pas compatible avec certains fournisseurs d'emails.

Nous vous conseillons d'utiliser Cleanfox avec une adresse mail compatible avec nos services. Vous pouvez voir la liste des fournisseurs d'emails compatibles [ici](#question-2-6).`
            },
            {
                ask: `Le scan tourne en boucle`,
                answer: `Lorsque vous utilisez Cleanfox pour la première fois, nous scanons l'intégralité de votre boite mail  pour repérer les newsletters et autres destinataires indésirables. Une fois cette étape passée, vous pouvez commencer à trier vos mails.
Cependant, il arrive parfois que le scan tourne en boucle pendant plusieurs heures. Si vous considérez l'attente trop longue, vous pouvez demander à nos équipes techniques de forcer la fin du scan pour pouvoir commencer à trier vos mails sans attendre.

Envoyez un mail à : [contact@cleanfox.io](mailto:contact@cleanfox.io) et nous vous répondrons dans les plus brefs délais.

Cependant, notez qu'il faut compter en moyenne 30mn à 2h pour que le scan soit effectué.`
            },
            {
                ask: `J'ai oublié mon mot de passe`,
                answer: `Pas besoin de mot de passe pour vous reconnecter à Cleanfox ! Nous avons souhaité rendre les choses faciles pour nos utilisateurs. Pour vous reconnecter à Cleanfox, cliquez sur "J'ai déjà un compte Cleanfox". Vous n'avez pas besoin de mot de passe à cette étape. Un lien de connexion vous sera envoyé directement dans votre boite mail.

Notez que le lien de connexion n'est valide qu'une heure. Passé ce délai, il vous faudra à nouveau faire la demande d'un lien de connexion.

Cependant, si vous ne voulez pas passer par le lien de connexion, vous pouvez recommencer les étapes de création de compte en cliquant sur "Commencer". Ces étapes sont détaillées **[ici](#question-2-1)**.`
            },
            {
                ask: `J'ai supprimé un email par erreur. Comment faire ? `,
                answer: `Les mails que Cleanfox supprime ne sont pas directement supprimés de votre boite mail. Vous pouvez les retrouver dans la corbeille de votre boite mail et récupérer les mails que vous avez accidentellement supprimés.

En fonction des fournisseurs de mails, vous avez de 5 à 30 jours avant que votre corbeille ne se vide automatiquement. Par exemple, Gmail supprime les éléments de la corbeille de plus de 30 jours, LaPoste de plus de 10 jours et SFR de plus de 5 jours seulement.

Concernant les newsletters que vous avez supprimé, vous pouvez les retrouver dans **Mes Actions**, en haut à droite de votre écran. Plus d'informations à ce sujet dans [Je me suis désabonné à une newsletter par erreur. Comment faire ?](#question-3-9)`
            },
            {
                ask: `Je souhaite trier plusieurs boites mails en même temps`,
                answer: `Pour ajouter une autre boite mail, il suffit d’aller dans vos **réglages**, puis **"vos boites mails"**, et cliquer sur "**ajouter une boite mail"**.

Cela vous permettra de trier plusieurs boites mails en même temps. Tous les mails s'afficheront au même endroit, et la boite mail concernée sera indiquée au niveau du tri.`
            },
            {
                ask: `J'aimerais supprimer mon compte Cleanfox`,
                answer: `Pour supprimer votre compte ainsi que toutes les données qui y sont associées, voici comment procéder :

1. Connectez-vous à votre compte Cleanfox
2. Cliquez sur "Mes Réglages", puis "Vos boites mails"
3. Choisissez votre adresse mail à supprimer et cliquez sur "Supprimer cette boite mail"

En cliquant sur "Supprimer cette boite mail", votre compte Cleanfox ainsi que toutes les données qui y sont associées seront supprimés. Attention, si vous avez effectué un nettoyage récemment et qu'il n'est pas encore effectif dans votre boite mail, la suppression de votre compte annulera ce nettoyage.`
            },
            {
                ask: `Comment se créer un compte Cleanfox avec une adresse Gmail ? `,
                answer: `Pour connecter de manière sécurisée votre boite mail à Cleanfox, vous allez devoir créer un mot de passe unique, dit mot de passe d'application, qui permettra à Cleanfox d'accéder à vos emails à trier sans connaitre votre mot de passe personnel.

**Pour cela, 2 à 3 étapes seront nécessaires**. Elles vous sont détaillées directement sur l'application Cleanfox. Nous vous conseillons de les suivre directement depuis votre application. En cas de problème, nous vous récapitulons les étapes ici :

## **POUR UNE CONNEXION AVEC VOTRE ORDINATEUR**

### **Etape 1 : Activez l’IMAP**

Cette étape est nécessaire pour que Cleanfox puisse détecter vos newsletters.

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox, ou rendez-vous dans votre boite Gmail, puis **"Paramètres"** et **"Transfert et POP/IMAP"**
2. Dans la section **Accès IMAP**, cliquez sur **Activer le protocole IMAP**.
3. Cliquez sur **Enregistrer les modifications** en bas de page (⚠️n’oubliez pas cette étape importante).
4. Retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.**

### **Etape 2 : Activez la validation en 2 étapes**

La validation à 2 étapes de Gmail ([2FA](https://www.google.com/landing/2step/?hl=fr)) vous permet de protéger votre compte à l’aide d’un **mot de passe.**

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox
2. Connectez-vous à votre compte Google avec votre identifiant et mot de passe Gmail.
3. Vous êtes automatiquement renvoyé sur la validation à deux étapes. cliquez sur **ACTIVER** pour activer la validation en deux étapes.
4. Retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.**

### **Etape 3 : Créez un mot d’application**

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox
2. **Connectez vous à nouveau à votre compte Google** avec votre identifiant et mot de passe Gmail.
3. Il vous est demandé de sélectionner l'application et l'appareil pour lesquels vous souhaitez générer le mot de passe d'application. Dans **"sélectionnez une application", choisissez "autre" et entrez "Cleanfox".**
4. Puis cliquez sur **Générer.**
5. **Copiez le mot de passe d'application et gardez le précieusement.** Ne le perdez pas avant la fin de la connexion !
6. Retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.**
7. Cliquez sur **"J'ai validé toutes ces étapes"**
8. Connectez vous en entrant à nouveau votre adresse Gmail et **votre mot de passe d'application** que vous avez copié précédemment.
9. Puis cliquez sur **Suivant.**

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**

Vous pouvez enfin [apprendre à utiliser Cleanfox](https://cleanfox.io/blog/fox-fr/comment-fonctionne-lapplication-cleanfox/) pour supprimer efficacement vos mails !

## **POUR UNE CONNEXION MOBILE**

Nous avons tout mis en oeuvre pour faciliter la connexion via notre application mobile. Ainsi, le nombre d'étapes est réduit, car nous avons automatisé certaines démarches.

### **Etape 1 : Activez la validation en 2 étapes**

La validation à 2 étapes de Gmail ([2FA](https://www.google.com/landing/2step/?hl=fr)) vous permet de protéger votre compte à l’aide d’un **mot de passe** et de votre **téléphone.**

La validation en 2 étapes peut se faire directement depuis l’application mobile Cleanfox. Suivez les étapes affichées sur votre écran.

1. Cliquez sur "C'est parti". Vous allez automatiquement être redirigé vers votre compte Google.
2. **Entrez votre adresse mail puis votre mot de passe Google**.
3. Rendez-vous sur votre application Gmail. **Cliquez sur "Oui" dans l'invitation** que vous avez reçu.
4. Une fois la connexion approuvée, **retournez sur votre application Cleanfox.**

### **Etape 2 : Créez un mot d’application et activez IMAP automatiquement**

Ce mot de passe est généré par Google pour Cleanfox uniquement.

1. Une fois sur l'application Cleanfox, re-connectez vous à votre compte Gmail pour activer la validation en deux étapes en insérant **votre mot de passe Gmail.**
2. Cliquez sur **Générer automatiquement.** Patientez quelques secondes.
3. Cliquez sur **Etape suivante**
4. Cliquez sur **Activer automatiquement.** Cela active le **protocole IMAP,** nécessaire pour que Cleanfox puisse détecter vos newsletters.
5. Puis sur **C’est Parti** pour vous connecter
6. Votre mot de passe d’application est rempli automatiquement, cliquez sur **Suivant**

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**

Vous pouvez enfin [apprendre à utiliser Cleanfox](#question-3-0) pour supprimer efficacement vos mails !

Vous trouverez plus d'information sur [notre blog](https://cleanfox.io/blog/astuces-gmail/comment-se-connecter-a-cleanfox-avec-une-adresse-gmail/).

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)`
            },
            {
                ask: `Comment se créer un compte Cleanfox avec une adresse Microsoft (Outlook, Hotmail) ? `,
                answer: `Pour connecter de manière sécurisée votre boite mail à Cleanfox, vous allez devoir créer un mot de passe unique, dit mot de passe d'application, qui permettra à Cleanfox d'accéder à vos emails à trier sans connaitre votre mot de passe personnel.

**Pour cela, 2 à 3 étapes seront nécessaires**. Elles vous sont détaillées directement sur l'application Cleanfox. Nous vous conseillons de les suivre directement depuis votre application. En cas de problème, nous vous récapitulons les étapes ici :

## **Comment se connecter à Cleanfox ?**

Il suffit d’effectuer 2 étapes en dehors de Cleanfox, directement depuis votre compte Hotmail / Outlook. On vous accompagne à chaque étape.

## **POUR UNE CONNEXION AVEC VOTRE ORDINATEUR**

## Etape 1 : Activez la vérification en deux étapes

La verification en deux étapes de [Microsoft](https://outlook.live.com/owa/) vous permet de protéger votre compte à l’aide d’un **mot de passe** et de votre **téléphone.**

Tout d’abord connectez-vous sur votre compte Hotmail/Outlook sur le site [Cleanfox.](http://cleanfox.io/) Pour cela, **entrez votre adresse mail.**

❓Si vous avez déjà activé la double authentication sur votre compte Microsoft, confirmez le code reçu par message et **allez directement à l’étape 2** pour créer un mot de passe d’application.

Sinon, vous devrez activer la vérification en 2 étapes, pour cela suivez les étapes suivantes:

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox.
2. Entrez le mot de passe de votre compte Microsoft.
3. Une fois connecté à votre compte Microsoft, vous tomberez sur la page "Configurer votre smartphone avec un mot de passe d’application". Cliquez sur "Suivant" jusqu'à tomber sur la page "Options de sécurité supplémentaires".
4. Descendez jusqu’à la section **“Vérification en deux étapes”.**
5. Cliquez sur **“Configurer la vérification en deux étapes”, puis suivez les instructions de Microsoft**

**Note**: Deux options sont envisageables pour activer la vérification en deux étapes avec votre compte Microsoft.

1. **Disposer d’une deuxième adresse mail**, différente de celle utilisée pour votre compte Microsoft
2. **Utiliser votre numéro de portable**, vous devrez alors installer l’application [Microsoft Authenticator](https://www.microsoft.com/fr-fr/account/authenticator) pour associer votre compte à votre numéro de téléphone.

Pour finir, retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.**

## Etape 2 : Créer un mot de passe d’application

Pour la deuxième étape, vous allez devoir **générer un mot de passe d’application.** Pour cela, suivez les étapes suivantes:

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox
2. Vous tomberez sur la page "Utiliser ce mot de passe d’application pour la connexion".
3. **Copiez le mot de passe d'application** affiché et retournez sur Cleanfox.
4. Cliquez sur **“J’ai validé toutes les étapes”**
5. Connectez vous en entrant à nouveau votre adresse Gmail et **votre mot de passe d'application** que vous avez copié précédemment.
6. Puis cliquez sur **Suivant.**

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)

## **POUR UNE CONNEXION MOBILE**

## Etape 1 : Activez la vérification en deux étapes

La verification en deux étapes de [Microsoft](https://outlook.live.com/owa/) vous permet de protéger votre compte à l’aide d’un **mot de passe** et de votre **téléphone.**

1. Rendez-vous sur votre application Cleanfox et cliquez sur Commencer.
2. Entrez votre adresse mail Microsoft.
3. Un récapitulatif des étapes sera affiché. Cliquez sur Suivant puis **"J'ai compris !".**
4. Vous allez être redirigé vers votre compte Microsoft. Renseignez **votre mot de passe Microsoft.**

❓Si vous avez déjà activé la double authentication sur votre compte Microsoft, vous devez vous rendre dans votre application Microsoft Authenticator pour approuver la demande.

**Sinon, vous devrez activer la vérification en 2 étapes**, pour cela suivez les étapes suivantes:

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox.
2. Entrez le mot de passe de votre compte Microsoft.
3. Une fois connecté à votre compte Microsoft, vous tomberez sur la page "Configurer votre smartphone avec un mot de passe d’application". Cliquez sur "Suivant" jusqu'à tomber sur la page "Options de sécurité supplémentaires".
4. Descendez jusqu’à la section **“Vérification en deux étapes”.**
5. Cliquez sur **“Configurer la vérification en deux étapes”, puis suivez les instructions de Microsoft**

**Note**: Deux options sont envisageables pour activer la vérification en deux étapes avec votre compte Microsoft.

1. **Disposer d’une deuxième adresse mail**, différente de celle utilisée pour votre compte Microsoft
2. **Utiliser votre numéro de portable**, vous devrez alors installer l’application [Microsoft Authenticator](https://www.microsoft.com/fr-fr/account/authenticator) pour associer votre compte à votre numéro de téléphone.

Pour finir, retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.**

### **Etape 2 : Créez un mot d’application automatiquement**

Microsoft va vous renvoyer automatiquement sur Cleanfox.

1. Cliquez sur **Générer automatiquement.** Patientez quelques secondes.
2. Cliquez sur **"C'est parti !"**
3. Vous arriverez sur une page "Connectez votre boîte mail". Le mot de passe d'application sera automatiquement collé. Cliquez sur **Suivant.**

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**

Vous pouvez enfin [apprendre à utiliser Cleanfox](#question-3-0) pour supprimer efficacement vos mails !

Vous trouverez plus d'information sur [notre blog](https://cleanfox.io/blog/astuces-hotmail-outlook/connexion_cleanfox-microsoft/).

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)`
            }
        ]
    },
    {
        img: '/img/static/faq/about.png',
        title: 'A propos de Cleanfox',
        questions: [
            {
                ask: `Qui sommes-nous ?`,
                answer: `Cleanfox est l’app la plus pratique et écolo pour vous désinscrire des newsletters polluantes. Avec Cleanfox, non seulement vous nettoyez votre boîte mail, mais vous réduisez également votre empreinte carbone !

Cleanfox est un produit développé par [Foxintelligence.](https://www.foxintelligence.fr/)
Nous sommes spécialisés dans les études de marché du e-commerce. Nous commercialisons des statistiques anonymisées sur le e-commerce.`
            },
            {
                ask: `Comment ça marche ? `,
                answer: `Le fonctionnement de Cleanfox est très simple. Notre algorithme scanne votre boite mail et détecte les newsletters et emails de confirmation de commande. Ensuite, Cleanfox vous propose de trier vos mails suivant trois options : 

*(1) supprimer vos anciens mails :* permet de conserver votre abonnement à la newsletter tout en plaçant vos anciens emails dans la corbeille de votre boîte de messagerie.

*(2) supprimer vos anciens mails et vous désabonner à la newsletter :* permet de résilier votre abonnement à la newsletter tout en plaçant les anciens emails dans la corbeille de votre boîte de messagerie. De plus, dans le cas où cet expéditeur continuerait à vous envoyer des emails, nous plaçons directement ses prochains emails dans la corbeille de votre boîte de messagerie.

*(3) garder vos mails*. 

En quelques clics, vous nettoyez votre boite mail et réduisez votre pollution numérique !`
            },
            {
                ask: `Est-ce payant d'utiliser Cleanfox ?`,
                answer: `Cleanfox est totalement gratuit, du téléchargement à l'utilisation. 

Pour en savoir plus sur comment nous nous rémunérons, nous vous invitons à vous rendre sur [cette page](privacy).`
            },
            {
                ask: `En quelles langues Cleanfox est-il disponible ? `,
                answer: `Pour l'instant, Cleanfox est disponible en français, anglais, allemand et espagnol. Nous travaillons à rendre Cleanfox disponible dans le plus de langues possibles.`
            },
            {
                ask: `Comment nous rémunérons-nous ?`,
                answer: `Notre business model est simple : nous utilisons des données entièrement anonymisées (générées à partir de confirmations de commandes également anonymisées) pour publier des statistiques sur le e-commerce.

Vous pouvez en savoir plus sur notre [page dédiée](my-data).`
            },
            {
                ask: `Sur quels supports puis-je utiliser Cleanfox ? `,
                answer: `Vous pouvez utiliser Cleanfox depuis vos appareils mobiles et vos ordinateurs, à savoir : smartphones, tablettes, ordinateurs portables et ordinateurs fixes. 

Pour les smartphones et tablettes : Cleanfox est disponible sous le format application, directement téléchargement sur le PlayStore pour les appareils Android et l'App Store pour les appareils Apple. 

Si vous disposez d'un compte Gmail ou Microsoft (Hotmail, Outlook ...), nous recommandons d'utiliser l'application car la connexion est facilitée. 

Pour les ordinateurs : Cleanfox est directement disponible depuis votre navigateur web, à l'adresse : [cleanfox.io](http://cleanfox.io)`
            }
        ]
    },
    {
        img: '/img/static/faq/connection.svg',
        title: 'Connexion',
        questions: [
            {
                ask: `Comment télécharger l'application mobile ?`,
                answer: `Android : Vous pouvez télécharger l'application mobile via le PlayStore d'Android à l'adresse suivante: [https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=fr](https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=fr)

Apple : Vous pouvez télécharger l'application mobile via le l'App Store d'Apple à l'adresse suivante : [https://apps.apple.com/fr/app/cleanfox-anti-spam-pub/id1136298377](https://apps.apple.com/fr/app/cleanfox-anti-spam-pub/id1136298377) 

Le téléchargement est gratuit.

L'application Cleanfox est uniquement téléchargeable pour les appareils mobiles ou tablettes. Si vous utilisez un ordinateur, vous pouvez directement accéder à Cleanfox via votre navigateur web, à l'adresse suivante : [cleanfox.io](http://cleanfox.io)`
            },
            {
                ask: `Comment se créer un compte Cleanfox ? `,
                answer: `Une fois sur l'application Cleanfox ou sur cleanfox.io, cliquez sur "Commencer" puis entrer votre adresse mail et cliquez sur "Suivant". Vous aurez accès à nos conditions générales d'utilisation, que vous pourrez lire. Dès que nous avons votre consentement, nous vous proposerons de vous créer un compte. 

Pour des raisons de sécurité et de confidentialité, la création d'un compte Cleanfox se fait en plusieurs étapes.  Toutes les étapes sont précisées directement sur l'application. Faites attention à les suivre minutieusement. 

Les étapes varient légèrement en fonction de votre fournisseur de messagerie, cependant elles suivent la même logique :

1. D'abord il vous faut activer la validation en deux étapes. Pour cela, cliquez directement sur le lien qui vous sera proposé dans l'application.
2. Ensuite, il vous faut créer un mot de passe d'application depuis votre boite mail. Un lien vous est également proposé à cette étape pour vous faire gagner du temps. 

Une fois ces deux étapes validées, renseignez le mot de passe d'application que vous venez de générer. 

Votre compte Cleanfox est créé ! Suivez le tutoriel puis commencez votre nettoyage. 

Pour plus de détails sur la création d'un compte à partir d'une **adresse Gmail**, rendez-vous [ici.](#question-0-7) 

Pour plus de détails sur la création d'un compte à partir d'une **adresse Outlook ou Hotmail**, rendez-vous [ici.](#question-2-10) 

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)`
            },
            {
                ask: `Comment se déroule l'inscription ? `,
                answer: `L’inscription est très facile et rapide :

1. Cliquez sur le bouton  “Commencer” sur notre page d’accueil.
2. Entrez l'adresse de la boite mail que vous souhaitez nettoyer.
3. Suivez les étapes de connexion. Pour plus d'aide à ce sujet, consultez notre [page dédiée](#question-2-1).
4. Après nous avoir donné un accès limité, Cleanfox scannera automatiquement votre boîte mail et réalisera la liste des newsletters auxquelles vous êtes abonné. Cela peut prendre un petit moment. 
5. Dès que le scan est réalisé, vous accéderez automatiquement à un petit tutoriel pour apprendre à trier vos mails.
6. Une fois le tutoriel fini, vous pouvez cliquer sur "Nettoyer ma boite mail". Vous aurez alors accès à la liste des newsletters que vous recevez et serez en mesure de nettoyer votre boîte de réception. Et voilà, le tour est joué !`
            },
            {
                ask: `J'ai déjà utilisé Cleanfox. Comment puis-je me reconnecter ? `,
                answer: `Si vous avez déjà un compte Cleanfox, vous pouvez vous reconnecter rapidement sans avoir à passer par la double authentification à nouveau. 

Rendez vous sur Cleanfox et **cliquez sur *"J'ai déjà utilisé Cleanfox"*** en haut à droite de la page d'accueil. Vous allez recevoir un mail avec un lien de reconnexion. Cliquez dessus. Vous voilà à nouveau connectés à Cleanfox !`
            },
            {
                ask: `J'ai oublié mon mot de passe`,
                answer: `Pas besoin de mot de passe pour vous reconnecter à Cleanfox ! Nous avons souhaité rendre les choses faciles pour nos utilisateurs. Pour vous reconnecter à Cleanfox, cliquez sur "J'ai déjà un compte Cleanfox". Vous n'avez pas besoin de mot de passe à cette étape. Un lien de connexion vous sera envoyé directement dans votre boite mail. 

Notez que le lien de connexion n'est valide qu'une heure. Passé ce délai, il vous faudra à nouveau faire la demande d'un lien de connexion. 

Cependant, si vous ne voulez pas passer par le lien de connexion, vous pouvez recommencer les étapes de création de compte en cliquant sur "Commencer". Ces étapes sont détaillées **[ici](#question-2-1)**.`
            },
            {
                ask: `Mon adresse mail n'est pas reconnue par Cleanfox`,
                answer: `Lors de la création de votre compte, il se peut que vous receviez le message d'erreur suivant : "Oops, .... n'est pas une adresse mail traitée par Cleanfox". 

En effet, Cleanfox ne traite pas les adresses mails personnalisées *(exemple : jeanne@dupont.fr)* et n'est pas compatible avec certains fournisseurs d'emails. 

Nous vous conseillons d'utiliser Cleanfox avec une adresse mail compatible avec nos services. Vous pouvez voir la liste des fournisseurs d'emails compatibles [ici](#question-2-6).`
            },
            {
                ask: `Quels sont les principaux fournisseurs d'emails compatibles avec Cleanfox ?`,
                answer: `A ce jour, tous les fournisseurs d'emails ne sont pas compatibles avec Cleanfox. Votre satisfaction est notre priorité et nous prenons régulièrement vos demandes pour ajouter de plus en plus de fournisseurs à notre liste. 

Liste des fournisseurs d'emails compatibles avec Cleanfox :

- Gmail
- Yahoo
- Microsoft (Hotmail et Outlook)
- Orange
- SFR
- La Poste
- Noos
- Numericable
- GMX
- BBOX (et Bouygtel)
- Apple et iCloud

❗️Free n'est plus compatible avec nos services. En savoir plus [ici](#question-2-7).`
            },
            {
                ask: `Pourquoi mon adresse mail Free n'est pas compatible avec Cleanfox ?`,
                answer: `Free a modifié ses Conditions Générales d'Utilisation refusant l'accès aux boîtes Free à des entreprises tierces, pour le moment les boîtes free ne peuvent être nettoyées par Cleanfox. Nous sommes actuellement en discussion avec ces derniers afin que vous puissiez utiliser Cleanfox.`
            },
            {
                ask: `Le scan tourne en boucle`,
                answer: `Lorsque vous utilisez Cleanfox pour la première fois, nous scanons l'intégralité de votre boite mail  pour repérer les newsletters et autres destinataires indésirables. Une fois cette étape passée, vous pouvez commencer à trier vos mails. 
Cependant, il arrive parfois que le scan tourne en boucle pendant plusieurs heures. Si vous considérez l'attente trop longue, vous pouvez demander à nos équipes techniques de forcer la fin du scan pour pouvoir commencer à trier vos mails sans attendre. 

Envoyez un mail à : [contact@cleanfox.io](mailto:contact@cleanfox.io) et nous vous répondrons dans les plus brefs délais. 

Cependant, notez qu'il faut compter en moyenne 30mn à 2h pour que le scan soit effectué.`
            },
            {
                ask: `Comment se créer un compte Cleanfox avec une adresse Gmail ? `,
                answer: `Pour connecter de manière sécurisée votre boite mail à Cleanfox, vous allez devoir créer un mot de passe unique, dit mot de passe d'application, qui permettra à Cleanfox d'accéder à vos emails à trier sans connaitre votre mot de passe personnel. 

**Pour cela, 3 étapes seront nécessaires**. Elles vous sont détaillées directement sur l'application Cleanfox. Nous vous conseillons de les suivre directement depuis votre application. En cas de problème, nous vous récapitulons les étapes ici : 

## **POUR UNE CONNEXION AVEC VOTRE ORDINATEUR**

### **Etape 1 : Activez l’IMAP**

Cette étape est nécessaire pour que Cleanfox puisse détecter vos newsletters.

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox, ou rendez-vous dans votre boite Gmail, puis **"Paramètres"** et **"Transfert et POP/IMAP"**
2. Dans la section **Accès IMAP**, cliquez sur **Activer le protocole IMAP**.
3. Cliquez sur **Enregistrer les modifications** en bas de page (⚠️n’oubliez pas cette étape importante).
4. Retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.** 

### **Etape 2 : Activez la validation en 2 étapes**

La validation à 2 étapes de Gmail ([2FA](https://www.google.com/landing/2step/?hl=fr)) vous permet de protéger votre compte à l’aide d’un **mot de passe.**

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox
2. Connectez-vous à votre compte Google avec votre identifiant et mot de passe Gmail. 
3. Vous êtes automatiquement renvoyé sur la validation à deux étapes. cliquez sur **ACTIVER** pour activer la validation en deux étapes.
4. Retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.** 

### **Etape 3 : Créez un mot d’application**

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox
2. **Connectez vous à nouveau à votre compte Google** avec votre identifiant et mot de passe Gmail.
3. Il vous est demandé de sélectionner l'application et l'appareil pour lesquels vous souhaitez générer le mot de passe d'application. Dans **"sélectionnez une application", choisissez "autre" et entrez "Cleanfox".** 
4. Puis cliquez sur **Générer.**
5. **Copiez le mot de passe d'application et gardez le précieusement.** Ne le perdez pas avant la fin de la connexion ! 
6. Retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.** 
7. Cliquez sur **"J'ai validé toutes ces étapes"** 
8. Connectez vous en entrant à nouveau votre adresse Gmail et **votre mot de passe d'application** que vous avez copié précédemment. 
9. Puis cliquez sur **Suivant.** 

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**  

Vous pouvez enfin [apprendre à utiliser Cleanfox](https://cleanfox.io/blog/fox-fr/comment-fonctionne-lapplication-cleanfox/) pour supprimer efficacement vos mails !

## **POUR UNE CONNEXION MOBILE**

Nous avons tout mis en oeuvre pour faciliter la connexion via notre application mobile. Ainsi, le nombre d'étapes est réduit, car nous avons automatisé certaines démarches.

### **Etape 1 : Activez la validation en 2 étapes**

La validation à 2 étapes de Gmail ([2FA](https://www.google.com/landing/2step/?hl=fr)) vous permet de protéger votre compte à l’aide d’un **mot de passe** et de votre **téléphone.**

La validation en 2 étapes peut se faire directement depuis l’application mobile Cleanfox. Suivez les étapes affichées sur votre écran. 

1. Cliquez sur "C'est parti". Vous allez automatiquement être redirigé vers votre compte Google. 
2. **Entrez votre adresse mail puis votre mot de passe Google**. 
3. Rendez-vous sur votre application Gmail. **Cliquez sur "Oui" dans l'invitation** que vous avez reçu. 
4. Une fois la connexion approuvée, **retournez sur votre application Cleanfox.** 

### **Etape 2 : Créez un mot d’application et activez IMAP automatiquement**

Ce mot de passe est généré par Google pour Cleanfox uniquement.

1. Une fois sur l'application Cleanfox, re-connectez vous à votre compte Gmail pour activer la validation en deux étapes en insérant **votre mot de passe Gmail.** 
2. Cliquez sur **Générer automatiquement.** Patientez quelques secondes.
3. Cliquez sur **Etape suivante**
4. Cliquez sur **Activer automatiquement.** Cela active le **protocole IMAP,** nécessaire pour que Cleanfox puisse détecter vos newsletters. 
5. Puis sur **C’est Parti** pour vous connecter
6. Votre mot de passe d’application est rempli automatiquement, cliquez sur **Suivant**

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**  

Vous pouvez enfin [apprendre à utiliser Cleanfox](#question-0-0) pour supprimer efficacement vos mails !

Vous trouverez plus d'information sur [notre blog](https://cleanfox.io/blog/astuces-gmail/comment-se-connecter-a-cleanfox-avec-une-adresse-gmail/).

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)`
            },
            {
                ask: `Comment se créer un compte Cleanfox avec une adresse Microsoft (Outlook, Hotmail) ? `,
                answer: `Pour connecter de manière sécurisée votre boite mail à Cleanfox, vous allez devoir créer un mot de passe unique, dit mot de passe d'application, qui permettra à Cleanfox d'accéder à vos emails à trier sans connaitre votre mot de passe personnel. 

**Pour cela, 2 à 3 étapes seront nécessaires**. Elles vous sont détaillées directement sur l'application Cleanfox. Nous vous conseillons de les suivre directement depuis votre application. En cas de problème, nous vous récapitulons les étapes ici : 

## **Comment se connecter à Cleanfox ?**

Il suffit d’effectuer 2 étapes en dehors de Cleanfox, directement depuis votre compte Hotmail / Outlook. On vous accompagne à chaque étape.

## **POUR UNE CONNEXION AVEC VOTRE ORDINATEUR**

## Etape 1 : Activez la vérification en deux étapes

La verification en deux étapes de [Microsoft](https://outlook.live.com/owa/) vous permet de protéger votre compte à l’aide d’un **mot de passe** et de votre **téléphone.**

Tout d’abord connectez-vous sur votre compte Hotmail/Outlook sur le site [Cleanfox.](http://cleanfox.io/) Pour cela, **entrez votre adresse mail.**

❓Si vous avez déjà activé la double authentication sur votre compte Microsoft, confirmez le code reçu par message et **allez directement à l’étape 2** pour créer un mot de passe d’application.

Sinon, vous devrez activer la vérification en 2 étapes, pour cela suivez les étapes suivantes:

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox. 
2. Entrez le mot de passe de votre compte Microsoft. 
3. Une fois connecté à votre compte Microsoft, vous tomberez sur la page "Configurer votre smartphone avec un mot de passe d’application". Cliquez sur "Suivant" jusqu'à tomber sur la page "Options de sécurité supplémentaires".
4. Descendez jusqu’à la section **“Vérification en deux étapes”.** 
5. Cliquez sur **“Configurer la vérification en deux étapes”, puis suivez les instructions de Microsoft**

**Note**: Deux options sont envisageables pour activer la vérification en deux étapes avec votre compte Microsoft.

1. **Disposer d’une deuxième adresse mail**, différente de celle utilisée pour votre compte Microsoft
2. **Utiliser votre numéro de portable**, vous devrez alors installer l’application [Microsoft Authenticator](https://www.microsoft.com/fr-fr/account/authenticator) pour associer votre compte à votre numéro de téléphone.

Pour finir, retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.** 

## Etape 2 : Créer un mot de passe d’application

Pour la deuxième étape, vous allez devoir **générer un mot de passe d’application.** Pour cela, suivez les étapes suivantes:

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox
2. Vous tomberez sur la page "Utiliser ce mot de passe d’application pour la connexion". 
3. **Copiez le mot de passe d'application** affiché et retournez sur Cleanfox. 
4. Cliquez sur **“J’ai validé toutes les étapes”**
5. Connectez vous en entrant à nouveau votre adresse Gmail et **votre mot de passe d'application** que vous avez copié précédemment. 
6. Puis cliquez sur **Suivant.** 

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**  

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)

## **POUR UNE CONNEXION MOBILE**

## Etape 1 : Activez la vérification en deux étapes

La verification en deux étapes de [Microsoft](https://outlook.live.com/owa/) vous permet de protéger votre compte à l’aide d’un **mot de passe** et de votre **téléphone.**

1. Rendez-vous sur votre application Cleanfox et cliquez sur Commencer.
2. Entrez votre adresse mail Microsoft. 
3. Un récapitulatif des étapes sera affiché. Cliquez sur Suivant puis **"J'ai compris !".** 
4. Vous allez être redirigé vers votre compte Microsoft. Renseignez **votre mot de passe Microsoft.** 

❓Si vous avez déjà activé la double authentication sur votre compte Microsoft, vous devez vous rendre dans votre application Microsoft Authenticator pour approuver la demande. 

**Sinon, vous devrez activer la vérification en 2 étapes**, pour cela suivez les étapes suivantes:

1. **Cliquez directement sur le lien proposé** dans l'application Cleanfox. 
2. Entrez le mot de passe de votre compte Microsoft. 
3. Une fois connecté à votre compte Microsoft, vous tomberez sur la page "Configurer votre smartphone avec un mot de passe d’application". Cliquez sur "Suivant" jusqu'à tomber sur la page "Options de sécurité supplémentaires".
4. Descendez jusqu’à la section **“Vérification en deux étapes”.** 
5. Cliquez sur **“Configurer la vérification en deux étapes”, puis suivez les instructions de Microsoft**

**Note**: Deux options sont envisageables pour activer la vérification en deux étapes avec votre compte Microsoft.

1. **Disposer d’une deuxième adresse mail**, différente de celle utilisée pour votre compte Microsoft
2. **Utiliser votre numéro de portable**, vous devrez alors installer l’application [Microsoft Authenticator](https://www.microsoft.com/fr-fr/account/authenticator) pour associer votre compte à votre numéro de téléphone.

Pour finir, retournez dans l'application Cleanfox et cliquez sur **J'ai validé cette étape.** 

### **Etape 2 : Créez un mot d’application automatiquement**

Microsoft va vous renvoyer automatiquement sur Cleanfox. 

1. Cliquez sur **Générer automatiquement.** Patientez quelques secondes.
2. Cliquez sur **"C'est parti !"**
3. Vous arriverez sur une page "Connectez votre boîte mail". Le mot de passe d'application sera automatiquement collé. Cliquez sur **Suivant.** 

Vous avez enfin fini ! **Votre compte est enfin sécurisé**. **Votre boite mail est ensuite scannée par Cleanfox. A la fin du scan, vous pourrez commencer votre tri !**  

Vous pouvez enfin [apprendre à utiliser Cleanfox](#question-0-0) pour supprimer efficacement vos mails !

Vous trouverez plus d'information sur [notre blog](https://cleanfox.io/blog/astuces-hotmail-outlook/connexion_cleanfox-microsoft/).

ℹ️ Si vous rencontrez toujours des problèmes de connexion, n'hésitez pas à contacter le support à l'adresse mail suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io)`
            }
        ]
    },
    {
        img: '/img/static/faq/usage.svg',
        title: 'Utilisation',
        questions: [
            {
                ask: `Comment trier mes mails avec Cleanfox ? (tutoriel) `,
                answer: `Rien de plus simple. Il y a trois options de tri et deux vues disponibles :

1. **La vue "carte"** qui permet de trier vos mails un par un, affichés sous forme de cartes. Pour trier vos mails, 3 mouvements :
- **Glissez vers la gauche pour vous désabonner**. Cette option place les mails de la newsletter dans la corbeille de votre boîte mail et vous désabonne à cette newsletter.
- **Glissez vers le haut pour supprimer.** Cette option place les mails reçus dans la corbeille de votre boîte mail mais conserve votre abonnement à la newsletter.
- **Glissez vers la droite pour conserver.** Cette option conserve tous les mails et l'abonnement à la newsletter.

2. **La vue "liste"** qui affiche la liste de toutes les newsletters à trier et vous permet d'en sélectionner plusieurs à la fois. Ici, pour trier, il vous suffit de cocher la/les newsletter(s) de votre choix et cliquer sur :

- **Le rond rouge pour vous désabonner**. Cette option place les mails de la newsletter dans la corbeille de votre boîte mail et vous désabonne à cette newsletter.
- **La poubelle orange pour supprimer.** Cette option place les mails reçus dans la corbeille de votre boîte mail mais conserve votre abonnement à la newsletter.
- **La boite verte pour conserver**. Cette option conserve tous les mails et l'abonnement à la newsletter.`
            },
            {
                ask: `Je souhaite trier plusieurs boites mails en même temps`,
                answer: `Pour ajouter une autre boite mail, il suffit d’aller dans vos réglages, puis "vos boites mails", et cliquer sur « ajouter une boite mail ».

Cela vous permettra de trier plusieurs boites mails en même temps. Tous les mails s'afficheront au même endroit, et la boite mail concernée sera indiquée au niveau du tri.`
            },
            {
                ask: `J'aimerais comprendre mes statistiques`,
                answer: `Au cours du nettoyage de votre boite mail, Cleanfox calcule trois statistiques : 

1. Le nombre de newsletters auxquelles vous vous êtes désabonné
2. Le nombre de mails supprimés 
3. Le nombre de CO2 économisés par an. 1 mail supprimé correspond à 10 grammes de CO2 économisé par an. 

Si vous réalisez des achats en ligne, Cleanfox analyse également leur impact carbone sur la planète, pour que vous puissiez transiter vers une consommation plus responsable, si cela vous intéresse.`
            },
            {
                ask: `J'ai supprimé un email par erreur. Comment faire ?`,
                answer: `Les mails que Cleanfox suppriment ne sont pas directement supprimés de votre boite mail. Vous pouvez les retrouver dans la corbeille de votre boite mail et récupérer les mails que vous avez accidentellement supprimés. 

En fonction des fournisseurs de mails, vous avez de 5 à 30 jours avant que votre corbeille ne se vide automatiquement. Par exemple, Gmail supprime les éléments de la corbeille de plus de 30 jours, LaPoste de plus de 10 jours et SFR de plus de 5 jours seulement. 

Concernant les newsletters que vous avez supprimé, vous pouvez les retrouver dans **Mes Actions**, en haut à droite de votre écran. Plus d'informations à ce sujet dans [Je me suis désabonné à une newsletter par erreur. Comment faire ?](#question-0-4)`
            },
            {
                ask: `Pourquoi les newsletters que j'ai supprimées apparaissent toujours dans ma boite mail ?`,
                answer: `Certaines newsletters demandent de remplir son mail et mot de passe pour se désabonner. Ainsi, il se peut que Cleanfox ne puisse pas systématiquement vous désabonner à certaines newsletters, pour des raisons évidentes de confidentialité. 

Pour ces cas particuliers, nous vous invitons à vous désabonner manuellement.`
            },
            {
                ask: `Ma boite mail est toujours remplie de spams`,
                answer: `C'est normal. Cleanfox ne nettoie pas les spams, mais les newsletters indésirables. Cependant, nous vous proposons des astuces pour nettoyer vos spams facilement dans [notre blog](https://cleanfox.io/blog/spam-fr/nettoyer-les-spams-de-son-e-mail/).`
            },
            {
                ask: `Cleanfox n'a pas vidé ma boite mail. J'ai toujours autant de mails. `,
                answer: `La suppression définitive de mails après avoir utilisé Cleanfox n'est pas toujours immédiate. En effet, il est probable que le processus s'étale sur plusieurs jours. Toutefois, si le problème persiste après avoir attendu un long moment, n'hésitez pas à nous contacter à l'adresse suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io). Nous prendrons en charge votre problème.`
            },
            {
                ask: `Comment puis-je parrainer mes amis ?`,
                answer: `Pour parrainer un ami, nous vous invitons à vous rendre dans l'onglet Statistiques de votre application. Dans "Parrainez vos amis", cliquez sur "Parrainage", où vous trouverez votre code de parrainage. 

Vous pouvez directement copier ce code et l'envoyer à vos amis ou utiliser les raccourcis Twitter, Whatsapp ou LinkedIn. 

Attention, ce code ne fonctionne que si la personne que vous parrainez utilise Cleanfox pour la première fois. 

🌱Cleanfox s'associe à WeForest et vous permet de planter un arbre pour chaque nouvelle personne que vous parrainez.`
            },
            {
                ask: `Comment puis-je bénéficier d'un parrainage ?`,
                answer: `Pour pouvoir bénéficier d'un parrainage, il faut que vous utilisiez le code de parrainage **lors de votre première utilisation de Cleanfox.** 

Au moment de l'inscription, après avoir renseigné votre nom et votre date de naissance, vous pourrez insérer le code de parrainage que votre ami vous aura transmis au préalable.`
            },
            {
                ask: `Je me suis désabonné à une newsletter par erreur. Comment faire ? `,
                answer: `Vous pouvez retrouver toutes les newsletters que vous avez décidé de garder ou auxquelles vous avez décidé de vous désabonner dans **Mes Actions**, en haut à droite de votre écran. Vos newsletters sont classés en deux catégories : 

- **les newsletters supprimées automatiquement** : cela correspond aux newsletters auxquelles vous avez décidé de vous désabonner. En cliquant sur le stylo en bas à droite de votre écran, vous pouvez cocher les newsletters que vous souhaitez récupérer. Attention à bien valider votre action en cliquant sur la flèche verte en bas à droite de votre écran.
- **les newsletters conservées** : cela correspond aux newsletters que vous avez décidé de garder. Là encore, vous pouvez modifier votre action en décidant de remettre les newsletters souhaitées dans votre liste de nettoyage.`
            },
        ]
    },
    {
        img: '/img/static/faq/privacy.svg',
        title: 'Sécurité et confidentialité',
        questions: [
            {
                ask: `A quoi sert l'authentification en deux étapes ?`,
                answer: `Cleanfox a choisi de garantir un niveau supérieur de confidentialité. Pour assurer la **sécurité de ses utilisateurs** nous avons renforcé la vérification des comptes. 

Nous avons donc rajouté quelques étapes pendant votre inscription. L’avantage pour vous, c’est que votre **compte est plus sécurisé. En effet, l'authentification en deux étapes vous permet de ne pas avoir à nous communiquer le mot de passe de votre boite mail.**

Pour connecter de manière sécurisée votre boite mail à Cleanfox, vous allez devoir créer un mot de passe unique, dit mot de passe d'application, qui permettra à Cleanfox d'accéder à vos emails à trier sans connaitre votre mot de passe personnel.`
            },
            {
                ask: `J'aimerais télécharger les données me concernant détenues par Cleanfox`,
                answer: `Dans le cadre de la règlementation RGPD, tous les utilisateurs Cleanfox peuvent exercer leur droit de portabilité, offrant la possibilité de récupérer une partie de leurs données dans un format ouvert et lisible par machine.

Pour télécharger vos données personnelles, vous devez être connecté sur votre compte Cleanfox. Une fois connecté, rendez-vous dans vos Réglages, puis Confidentialité. En bas de la page, vous trouverez un lien de téléchargement.  

**Attention, vous pouvez télécharger vos données personnelles uniquement sur web (donc en utilisant votre ordinateur).**`
            },
            {
                ask: `Je souhaite que mes données ne soient pas utilisées à des fins statistiques`,
                answer: `Chez Cleanfox, nous laissons toujours le choix à nos utilisateurs. Ainsi, si vous souhaitez que nous n'utilisions pas vos données à des fins statistiques, vous pouvez sortir du panel anonymisé de Foxintelligence. Pour cela, rendez-vous dans vos Réglages, Vos boites mails, Panel Foxintelligence.`
            },
            {
                ask: `Comment les données récoltées par Cleanfox sont-elles utilisées ? `,
                answer: `Nos statistiques anonymisées sont destinées aux entreprises qui veulent en savoir plus sur leur activité, leurs marchés ou leurs concurrents.

Trois exemples d'application : 

Déterminer la part de marché : Nous sommes capables de déduire la part de marché des entreprises sur leur secteur, uniquement à partir des confirmations de commande.

Déterminer la fidélité des clients : Nous offrons aux entreprises une vision sur leurs concurrents chez qui leurs clients commandent. Ainsi, nous leur permettons de mesurer la fidélité de leurs clients à leur marque.

Déterminer la sensibilité à une promotion : Nous sommes capables de déterminer l'impact d'une promotion sur le nombre de commandes. 

Nous avons fait le choix de ne jamais utiliser de données à des fins publicitaires.

Plus d'informations sur notre [page dédiée](my-data).

ℹ️ Chez Cleanfox, nous laissons toujours le choix à nos utilisateurs. Ainsi, si vous souhaitez que nous n'utilisions pas vos données à des fins statistiques, vous pouvez sortir du panel anonymisé de Foxintelligence. Pour cela, rendez-vous dans vos Réglages, Vos boites mails, Panel Foxintelligence.`
            },
            {
                ask: `Quelles sont les données récupérées par Cleanfox ?`,
                answer: `Nos algorithmes sont conçus pour uniquement traiter les newsletters et les confirmations de commande.

D’abord, nous recueillons quelques informations de contact de base lors de la création de votre compte. Ensuite, avec votre accord, nous connectons Cleanfox à votre/vos boite(s) mail(s). Nous n’avons jamais vendu, nous ne vendons pas et nous ne vendrons jamais de données personnelles.

Plus d'informations sur notre [page dédiée](my-data)`
            },
            {
                ask: `Est-ce que Cleanfox peut lire mes mails ? `,
                answer: `Dans notre processus automatisé des traitements des newsletters et données transactionnelles, tous les mails personnels sont ignorés, et exclus de tout accès par nos systèmes. L'extraction des données transactionnelles est réalisée par des algorithmes (type regex). Ces algorithmes savent exactement quel expéditeur de confirmation de commande rechercher (e.g, [confirmation-commande@amazon.fr](mailto:confirmation-commande@amazon.fr)) et ne peuvent en aucun cas extraire des données non attendues.
Ces données sont non-personnelles, anonymisées et ne nourrissent qu'un seul but : être agrégées afin de réaliser des études de marché sur le e-commerce.

Notre entreprise repose sur les principes fondamentaux de ne jamais générer le moindre préjudice pour nos utilisateurs, de ne jamais transmettre ou exploiter leurs données personnelles et de ne jamais nourrir l'industrie publicitaire (audience, targeting cookies, etc.). Nous mettons enfin un point d'honneur à être transparent sur toute la ligne avec nos utilisateurs (en partant d'un consentement clair).

En savoir plus sur notre [page dédiée](privacy)`
            },
            {
                ask: `J'aimerais supprimer mon compte Cleanfox`,
                answer: `Pour supprimer votre compte ainsi que toutes les données qui y sont associées, voici comment procéder : 

1. Connectez-vous à votre compte Cleanfox
2. Cliquez sur "Mes Réglages", puis "Vos boites mails"
3. Choisissez votre adresse mail à supprimer et cliquez sur "Supprimer cette boite mail"

En cliquant sur "Supprimer cette boite mail", votre compte Cleanfox ainsi que toutes les données qui y sont associées seront supprimés. Attention, si vous avez effectué un nettoyage récemment et qu'il n'est pas encore effectif dans votre boite mail, la suppression de votre compte annulera ce nettoyage.`
            },
            {
                ask: `Comment Cleanfox se connecte-t-il à ma boîte mail ?`,
                answer: `Pour nous connecter, nous utilisons le protocole IMAP et le mot de passe d'application.`
            },
            {
                ask: `Pourquoi est-ce que mon service email me prévient-il que quelqu’un utilise IMAP d’une autre position géographique ?`,
                answer: `Nous utilisons IMAP pour nous connecter à votre boîte email — no stress, tout est parfaitement normal ! 

En effet, nos serveurs sont situés en Allemagne ; il est donc normal que vous receviez ce type d'email lorsque nous scanons votre boite mail.`
            }
        ]
    },
    {
        img: '/img/static/faq/pollution.svg',
        title: 'Pollution numérique',
        questions: [
            {
                ask: `Comment planter des arbres avec Cleanfox ? `,
                answer: `En parallèle de son service de nettoyage de boîtes mail, Cleanfox veut augmenter son impact positif sur l’environnement. Pour cela, nous avons noué un partenariat avec l’association WeForest pour participer au financement d’un projet de reforestation en Zambie. En effet, pour chaque personne parrainée sur Cleanfox, un arbre est planté en Zambie.

Pour en savoir plus sur le projet de l'organisation WeForest: [https://www.weforest.org/](https://www.weforest.org/).`
            },
            {
                ask: `Puis-je réellement réduire mon empreinte carbone en utilisant Cleanfox ?`,
                answer: `Oui !

Depuis son lancement, Cleanfox a supprimé plusieurs centaines de millions d’emails, réduisant ainsi les émissions de Co2 de ses utilisateurs. 

Plus d'infos sur: [Pourquoi les mails polluent ?](https://cleanfox.io/blog/impact-carbone/pollution-des-mails-et-emissions-de-co2/) 

Egalement, grâce à notre fonctionnalité Stories, vous pouvez suivre votre consommation tous les mois et l'adapter en fonction de vos objectifs écologiques. 

La planète vous remercie !`
            },
            {
                ask: `En quoi les mails participent-ils à la pollution numérique ?`,
                answer: `Les mails font partie du quotidien de la majorité des utilisateurs d'appareils numérique. Un mail génère environ 10 grammes de CO2 par an. Cela vous parait peu ? Il suffit de le ramener à l'échelle de la France, qui envoie 1,4 milliards de mails par jour ! 

Non seulement l'envoi des mails est un facteur majeur de pollution numérique, mais leur stockage l'est également. En effet, seulement 60% des mails et 10% des newsletters sont ouverts. Un stockage qui coute également à la planète.

Ainsi, un utilisateur Cleanfox économise ainsi **en moyenne 6kg de CO2 par an** en nettoyant sa boîte mail. Nettoyez votre boîte mail, vous réduirez directement votre empreinte carbone ! 

Vous pouvez en savoir plus en téléchargeant notre [Livre Blanc](https://cleanfox.io/blog/a-la-une-sur-cleanfox-fr/livre-blanc-la-pollution-numerique-liee-aux-mails/) à ce sujet ou sur notre article de blog dédié [Pourquoi les mails polluent ?](https://cleanfox.io/blog/impact-carbone/pollution-des-mails-et-emissions-de-co2/)`
            },
            {
                ask: `Et pour mes transactions e-commerce, quelle est l'implication écologique ?`,
                answer: `Avec l'explosion du e-commerce, les achats en ligne ont un impact de plus en plus important sur l'environnement. De la commande en ligne à la livraison de la commande, toutes les étapes contribuent à polluer la planète.

Dans les Stories, sur votre page Statistiques, vous pouvez trouver des conseils sur comment réduire votre empreinte carbone, ainsi que des détails sur votre activité en ligne, afin d'adapter votre consommation en fonction de vos objectifs.`
            }
        ]
    },
    {
        img: '/img/static/faq/miscellaneous.svg',
        title: 'Autre',
        questions: [
            {
                ask: `J'aimerais suggérer une nouvelle fonctionnalité ou vous donner mon avis`,
                answer: `Chez Cleanfox, nous sommes très attachés à la satisfaction de nos utilisateurs. Nous prenons en considération toutes vos remarques et suggestions. 

Vous pouvez noter Cleanfox directement depuis l'application dans Réglages → Noter Cleanfox. 

Vous pouvez également nous écrire à l'adresse suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io), nous serons ravis de vous lire !`
            },
            {
                ask: `Je ne trouve pas de réponse à ma problématique dans la FAQ`,
                answer: `Si vous ne trouvez pas réponses à vos questions dans notre FAQ, ou que votre problème demande une assistance, vous pouvez directement nous contacter par mail à l'adresse suivante : [contact@cleanfox.io](mailto:contact@cleanfox.io) Nous répondons généralement sur 24 à 48h. 

❗️Le support technique n'est disponible que dans deux langues: français et anglais. Merci de faire attention à rédiger votre mail dans l'une de ces deux langues.`
            },
            {
                ask: `J'aimerais contacter le support technique`,
                answer: `Pour contacter le support technique, il vous faut envoyer un mail à : [contact@cleanfox.io](mailto:contact@cleanfox.io)

❗️Le support technique n'est disponible que dans deux langues: français et anglais. Merci de faire attention à rédiger votre mail dans l'une de ces deux langues. 

Pour faciliter la réponse du support technique, nous vous recommandons de préciser dans votre demande : 

- Le support utilisé : Mobile ou ordinateur ?
    - Si mobile : iOS ou Android ?
- Votre adresse mail
- Les étapes effectuées avant de rencontrer votre problématique
- Si possible, une capture d'écran de votre message d'erreur / bug

Nous répondons généralement sous 24 à 48h maximum (jours ouvrés).`
            }
        ]
    }
]

export default faq
